module.exports = __webpack_public_path__ + "img/text.1126277d.webp";